import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GetBeersDTO} from 'typescript/dto/beersDto';
import {Beer} from 'typescript/models/Beer';
import BeerStyle from 'typescript/models/BeerStyle';
import BeersIncluded from 'typescript/types/BeersIncluded';

interface IState {
  singleBeerStyle: BeerStyle | null;
  beersList: {
    filters: GetBeersDTO;
    styleBeers: Beer[];
    styleBeersIncluded: BeersIncluded[];
    checkedBeerStyles: string[];
    totalPages: number;
    totalCount: number;
  };
}

const initialState: IState = {
  singleBeerStyle: null,
  beersList: {
    filters: {page: 1, perPage: 5, name: '', direction: 'asc', column: 'name'},
    styleBeers: [],
    styleBeersIncluded: [],
    checkedBeerStyles: [],
    totalPages: 1,
    totalCount: 0,
  },
};

export const beerStyleViewNamespace = '[beer_style]';

const beerStyleViewSlice = createSlice({
  name: beerStyleViewNamespace,
  initialState,
  reducers: {
    setSingleBeerStyleAC: (state, action: PayloadAction<IState['singleBeerStyle']>) => {
      state.singleBeerStyle = action.payload;
    },
    setSingleStyleBeerFiltersAC: (state, action: PayloadAction<GetBeersDTO>) => {
      state.beersList.filters = action.payload;
    },
    setStyleBeersAC: (state, action: PayloadAction<Beer[]>) => {
      state.beersList.styleBeers = action.payload;
    },
    setStyleBeersPageInfoAC: (state, action: PayloadAction<{totalCount: number; totalPages: number}>) => {
      state.beersList.totalPages = action.payload.totalPages;
      state.beersList.totalCount = action.payload.totalCount;
    },
    setStyleBeersIncludedAC: (state, action: PayloadAction<BeersIncluded[]>) => {
      state.beersList.styleBeersIncluded = action.payload;
    },
  },
});

export default beerStyleViewSlice;

export const {
  setSingleBeerStyleAC,
  setSingleStyleBeerFiltersAC,
  setStyleBeersAC,
  setStyleBeersPageInfoAC,
  setStyleBeersIncludedAC,
} = beerStyleViewSlice.actions;
